import type * as React from 'react';
import { put } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import userActivated, { type UserActivatedAction } from '@Application/Users/Users/Actions/userActivated';
import userActivationFailed, {
	type UserActivationFailedAction,
} from '@Application/Users/Users/Actions/userActivationFailed';
import type ActivateUser from '@Application/Users/Users/Commands/ActivateUser';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserActivatedAction | UserActivationFailedAction;

export default (command: ActivateUser) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}/activation`,
				{},
			);

			const action = userActivated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userActivationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
